import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';

import { mapGetters } from "vuex";

export default {
    name: "paymentMethod",
    components: {
        MainLayout,
        BadgerAccordion,
        BadgerAccordionItem
    },

    data() {
        return {
            payments: []
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getPaymentDetail() {
            axios.get("/payment-methods")
                .then(response => {
                    this.payments = response.data.data.map(payment => ({
                        ...payment,
                        hidden: true, // Initialize 'hidden' property
                      }));
                })
                .catch(error => {
                    console.log(error, "error");
                });
        }, 

        togglePayment(payment) {
            payment.hidden = !payment.hidden;
        },
    },

    mounted() {
        this.getPaymentDetail();
    }
};
